import * as React from 'react';
import { useTranslation } from 'react-i18next';
import ServiceSummary from '../../ServiceSummary';
import { CartContext } from '../Cart';
import { CheckoutSteps } from '../../MobileStepbar/types';
import BaggageSummary from '../../ServiceSummary/services/BaggageSummary';
import { CdnIcon } from '@shared/ui';
const Baggage = ({ onServiceDelete, renderService, activeStep, steps }) => {
    var _a;
    const cartConfig = React.useContext(CartContext);
    const { t } = useTranslation('Cart');
    const group = {
        header: t('Baggage'),
        icon: React.createElement(CdnIcon, { icon: 'Baggage/Checked-in' }),
        totalPrice: (_a = cartConfig.totalPrices) === null || _a === void 0 ? void 0 : _a.baggage,
        disabled: activeStep < (steps === null || steps === void 0 ? void 0 : steps.findIndex(step => step.type === CheckoutSteps.Baggage)) || false
    };
    return (React.createElement(BaggageSummary, { onServiceDelete: onServiceDelete }, content => {
        var _a;
        return (_a = renderService === null || renderService === void 0 ? void 0 : renderService(CheckoutSteps.Baggage, group, content)) !== null && _a !== void 0 ? _a : (React.createElement(ServiceSummary, { group: group }, content));
    }));
};
export default Baggage;
